// context/BurgerMenuContext/BurgerMenuContext.tsx
import { createContext, useContext, useState, ReactNode } from 'react'

interface BurgerMenuContextType {
  isOpen: boolean
  openMenu: () => void
  closeMenu: () => void
  toggleMenu: () => void
}

const BurgerMenuContext = createContext<BurgerMenuContextType | null>(null)

export const useBurgerMenu = () => {
  const context = useContext(BurgerMenuContext)
  if (!context) {
    throw new Error('useBurgerMenu must be used within BurgerMenuProvider')
  }
  
  return context
}

export const BurgerMenuProvider = ({ children }: { children: ReactNode }) => {
  const [isOpen, setIsOpen] = useState(false)

  const openMenu = () => setIsOpen(true)
  const closeMenu = () => setIsOpen(false)
  const toggleMenu = () => setIsOpen(prev => !prev)

  return (
    <BurgerMenuContext.Provider value={{ isOpen, openMenu, closeMenu, toggleMenu }}>
      {children}
    </BurgerMenuContext.Provider>
  )
}
